import _regeneratorRuntime from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/project/workspaces/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


import { ConsoleLogger as Logger } from '../Logger';
import { browserOrNode } from '../JS';
var logger = new Logger('CognitoCredentials');
var waitForInit = new Promise(function (res, rej) {
  if (!browserOrNode().isBrowser) {
    logger.debug('not in the browser, directly resolved');
    return res();
  }

  var fb = window['FB'];

  if (fb) {
    logger.debug('FB SDK already loaded');
    return res();
  } else {
    setTimeout(function () {
      return res();
    }, 2000);
  }
});
export var FacebookOAuth = /*#__PURE__*/function () {
  function FacebookOAuth() {
    _classCallCheck(this, FacebookOAuth);

    this.initialized = false;
    this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
    this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
  }

  _createClass(FacebookOAuth, [{
    key: "refreshFacebookToken",
    value: function refreshFacebookToken() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.initialized) {
                  _context.next = 6;
                  break;
                }

                logger.debug('need to wait for the Facebook SDK loaded');
                _context.next = 4;
                return waitForInit;

              case 4:
                this.initialized = true;
                logger.debug('finish waiting');

              case 6:
                return _context.abrupt("return", this._refreshFacebookTokenImpl());

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "_refreshFacebookTokenImpl",
    value: function _refreshFacebookTokenImpl() {
      var fb = null;
      if (browserOrNode().isBrowser) fb = window['FB'];

      if (!fb) {
        logger.debug('no fb sdk available');
        return Promise.reject('no fb sdk available');
      }

      return new Promise(function (res, rej) {
        fb.getLoginStatus(function (fbResponse) {
          if (!fbResponse || !fbResponse.authResponse) {
            logger.debug('no response from facebook when refreshing the jwt token');
            rej('no response from facebook when refreshing the jwt token');
          }

          var response = fbResponse.authResponse;
          var accessToken = response.accessToken,
              expiresIn = response.expiresIn;
          var date = new Date();
          var expires_at = expiresIn * 1000 + date.getTime();

          if (!accessToken) {
            logger.debug('the jwtToken is undefined');
            rej('the jwtToken is undefined');
          }

          res({
            token: accessToken,
            expires_at: expires_at
          });
        }, {
          scope: 'public_profile,email'
        });
      });
    }
  }]);

  return FacebookOAuth;
}();
/**
 * @deprecated use named import
 */

export default FacebookOAuth;